<template>
    <div>
        <div class="vrm-slider__top-values">
            <div class="vrm-slider__top-value">
                <span class="vrm-slider__top-first">{{ tempMinSoc || 0 }}%</span>
                <span
                    class="vrm-slider__top-second"
                    v-html="$t('dashboard.dci.ess_auto_min_info')"
                ></span>
            </div>
            <div v-if="withDess" class="vrm-slider__top-value">
                <span class="vrm-slider__top-first">{{ tempDessSoc || 0 }}%</span>
                <span
                    class="vrm-slider__top-second"
                    v-html="$t('dashboard.dci.ess_auto_max_info')"
                ></span>
            </div>
        </div>
        <div class="vrm-ess-battery-container">
            <Slider
                :value="values"
                :classes="{
                    target: 'vrm-ess-battery',
                    //Add separate class name to the touch(drag) area on mobile for google tag manager
                    touchArea: isMobile
                        ? 'slider-touch-area slider-touch-area-mobile'
                        : 'slider-touch-area',
                }"
                :step="5"
                :format="format"
                :merge="40"
                :disabled="disabled"
                :options="sliderOptions"
                @change="onChange"
                @update="updateValues"
            ></Slider>
        </div>
        <div v-if="activeSoc !== null" class="vrm-info-box dci-active-soc">
            <span class="sg-vrm-icon_061_info-round-16px"></span>
            <span
                v-html="
                    $t(`dashboard.dci.ess_active_soc`, {
                        value: activeSoc,
                    })
                "
            ></span>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Slider from '@ni3k/vueform-slider/dist/slider.vue2.js';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: {
        Slider,
    },
})
@AngularLocaleBundle('dashboard')
export default class BatterySlider extends Vue {
    @Prop({ type: Boolean })
    withDess;
    @Prop({ type: Boolean })
    disabled;
    @Prop()
    minSoc;
    @Prop()
    dessSoc;
    @Prop()
    activeSoc;

    tempMinSoc = 0;
    tempDessSoc = 0;
    isMobile = window.innerWidth <= 750;

    mounted() {
        window.addEventListener('resize', this.handleResize);
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.isMobile = window.innerWidth <= 750;
    }

    @Watch('minSoc', { immediate: true })
    onMinSocChanged(value) {
        this.tempMinSoc = value;
    }

    @Watch('dessSoc', { immediate: true })
    onDessSocChanged(value) {
        this.tempDessSoc = value;
    }

    get values() {
        return this.withDess ? [this.tempMinSoc, this.tempDessSoc] : [this.tempMinSoc];
    }

    get connect() {
        return this.withDess ? [false, false, false] : [true, false];
    }

    get format() {
        return this.withDess
            ? [
                  value => this.$t('dashboard.dci.slider_minimum', { value: value || 0 }),
                  value => this.$t('dashboard.dci.slider_dess', { value: value || 0 }),
              ]
            : [value => this.$t('dashboard.dci.slider_minimum', { value: value || 0 })];
    }

    //For mobile, do not let scrolling change the soc values, force the user to drag instead
    get sliderOptions() {
        return this.isMobile
            ? { connect: this.connect, behaviour: 'drag' }
            : { connect: this.connect };
    }

    onChange(values) {
        Array.isArray(values) ? this.$emit('change', values) : this.$emit('change', [values]);
    }

    updateValues(values) {
        if (Array.isArray(values)) {
            this.tempMinSoc = values[0];
            if (values.length > 1) {
                this.tempDessSoc = values[1];
            }
        } else {
            this.tempMinSoc = values;
        }
    }
}
</script>
